import gql from "graphql-tag";
const PAGES = gql`
	query (
		$take: Int
	) {
		pages(take: $take) {
			items {
				id
				createdBy {
					id
					name
				}
				createdOn
				modifiedBy {
					id
					name
				}
				modifiedOn
				title
				code
				titleFileId
				group {
					id
					name
				}
			}
		}
	}
`;
const PAGES_SECTION = gql`
	query (
		$where: PageFilterInput
		$order: [PageSortInput!]
		$skip: Int
		$take: Int
	) {
		pages(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				createdBy {
					id
					name
				}
				createdOn
				modifiedBy {
					id
					name
				}
				modifiedOn
				title
				code
				titleFileId
				group {
					id
					name
				}
			}
		}
	}
`;
const PAGE_FOR_VIEW = gql`
	query ($where: PagesQueryResponseFilterInput) {
		pagesWithLike(where: $where) {
			items {
				isLiked
				isDisliked
				likesCount
				dislikesCount
				isFavorite
				entity {
					id
					createdOn
					title
					code
					content
					titleFileId
					useReactions
					useComments
				}
			}
		}
	}
`;
const PAGES_FOR_EDIT = gql`
	query ($where: PageFilterInput) {
		items: pagesForEdit(where: $where) {
			items {
				id
				createdBy {
					name
				}
				createdOn
				modifiedBy {
					name
				}
				modifiedOn
				title
				metaTitle
				metaDescription
				content
				code
				culture {
					id
				}
				titleFileId
				group {
					id
					name
				}
				tags {
					id
					name
				}
				useReactions
				useComments
			}
		}
	}
`;
const PAGE_TAGS = gql`
	query (
		$where: TagFilterInput
		$order: [TagSortInput!]
		$skip: Int
		$take: Int
	) {
		pageTags(where: $where, order: $order, skip: $skip, take: $take) {
			__pageInfo: pageInfo {
				hasNextPage
			}
			__items: items {
				id
				name
			}
		}
	}
`;
const DELETE_PAGES_TAG = gql`
	mutation ($id: UUID!) {
		deletePagesTag(id: $id)
	}
`;
const ADD_OR_EDIT_PAGE = gql`
	mutation ($inputs: [PageInput!]!) {
		result: addOrEditPage(inputs: $inputs)
	}
`;
const DELETE_PAGE = gql`
	mutation ($code: String!) {
		deletePage(code: $code)
	}
`;
const ADD_PAGE_REACTION = gql`
	mutation ($input: BaseEntityReactionInput!) {
		addPageReaction(input: $input) {
			isLiked
			isDisliked
			likesCount
			dislikesCount
		}
	}
`;
const USER_TEMPLATES = gql`
	query {
		userTemplates {
			items {
				id
				key
				name
				template
				createdBy {
					id
					name
				}
				isPublic
			}
		}
	}
`;
const ADD_OR_EDIT_USER_TEMPLATE = gql`
	mutation ($input: UserTemplateInput!) {
		addOrEditUserTemplate(input: $input) {
			id
			isPublic
		}
	}
`;
export {
  ADD_OR_EDIT_PAGE,
  ADD_OR_EDIT_USER_TEMPLATE,
  ADD_PAGE_REACTION,
  DELETE_PAGE,
  DELETE_PAGES_TAG,
  PAGES,
  PAGES_FOR_EDIT,
  PAGES_SECTION,
  PAGE_FOR_VIEW,
  PAGE_TAGS,
  USER_TEMPLATES
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
